import React from 'react'
import classNames from 'classnames'


const Button = (props) => {
    const { coloring, type } = props
    const classes = classNames(
        'usa-button',
        {
            'usa-button-alert': coloring === 'alert',
            'usa-button-alert-fill': coloring === 'alert-fill',
            'usa-button--secondary': coloring === 'red' || coloring === 'secondary',
            'usa-button usa-button-primary': coloring === 'blue' || coloring === 'primary',
            'usa-button--outline': coloring === 'outline',
            'usa-button-outline-cancel': coloring === 'cancel',
            'usa-button-submission': coloring === 'green' || coloring === 'submit'
        }
    )
    return(
        <button type={type || "button"} className={classes} {...props}>{props.children}</button>
    )
}

export default Button